export enum EnvRegion {
  CN_TEST = "CN-TEST",
  OR_TEST = "OR-TEST",
  CN_STAG = "CN-STAG",
  OR_STAG = "OR-STAG",
  CN_PROD = "CN-PROD",
  OR_PROD = "OR-PROD",
}
export const getEnvRegion = () => {
  return process.env.NEXT_PUBLIC_REGION as EnvRegion;
};

export const isOverseaEnv = () => {
  return [EnvRegion.OR_TEST, EnvRegion.OR_STAG, EnvRegion.OR_PROD].includes(
    getEnvRegion(),
  );
};
